import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AppToastComponent} from './components/app-toast/app-toast.component';
import {AppToasterComponent} from './components/toaster/app-toaster.component';
import {PriorityDropdownComponent} from './components/priority-dropdown/priority-dropdown.component';
import {CalendarModule, DropdownModule, MultiSelectModule} from 'primeng/primeng';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CGSearchComponent } from './components/cg-search/cg-search.component';
import {SharedSortFilterMenuComponent} from './components/shared-sort-filter-menu/shared-sort-filter-menu.component';
import {SharedMyButtonDirective} from './directives/shared-my-button.directive';
import { SearchHighlightDirective } from './directives/search-highlight.directive';
import { CopyPlanFormComponent } from './components/copy-plan-form/copy-plan-form.component';
import {AppLoadingPanelModule} from '../app-loading-panel/app-loading-panel.module';
import {AppErrorMsgModule} from '../app-error-msg/app-error-msg.module';

@NgModule({
  imports: [
    CommonModule,
    MultiSelectModule,
    DropdownModule,
    FormsModule,
    AppLoadingPanelModule,
    AppErrorMsgModule,
    ReactiveFormsModule,
    CalendarModule
  ],
  declarations: [
    AppToastComponent,
    AppToasterComponent,
    PriorityDropdownComponent,
    CGSearchComponent,
    SharedSortFilterMenuComponent,
    SharedMyButtonDirective,
    SearchHighlightDirective,
    CopyPlanFormComponent
  ],
    exports: [
        AppToastComponent,
        AppToasterComponent,
        PriorityDropdownComponent,
        CGSearchComponent,
        SharedSortFilterMenuComponent,
        SharedMyButtonDirective,
        SearchHighlightDirective,
        CopyPlanFormComponent
    ]
})
export class SharedModule { }
